import styled from "@emotion/styled";
import { Box, Typography, TextField, CircularProgress, Button } from "@mui/material"
import formatMoney from "../utils/formatMoney";
import { LOT_STATUS } from "../utils/constants";

const Title = styled(Typography)(
  ({ theme }) => ({
    margin: 0,
    marginTop: 0,
    font: "Arial",
    fontSize: 25,
    color: theme.palette.primary.main
  }),
  props => ({
    color: props.color,
    fontSize: props.size,
    marginTop: props.marginTop,
    width: props.width,
    marginLeft: props.marginLeft,
  })
);

const NormalText = styled(Typography)(
  ({ theme }) => ({
    font: "Arial",
    fontFamily: 'ITC Officina Sans Std, Book',
    fontSize: 15,
    color: theme.palette.white.main
  }),
  props => ({
    color: props.color,
    fontSize: props.fontSize,
    flex: props.flex
  })
);

const NumberText = styled(Typography)(
  ({ theme }) => ({
    font: "Arial",
    fontSize: 15,
    fontFamily: "'ITC Officina Sans Std, Book'",
    color: theme.palette.black.main
  }),
  props => ({
    color: props.color,
    fontSize: props.size,
    marginRight: props.marginRight,
    marginBottom: props.marginBottom
  }),

);

const Field = styled(TextField)(
  ({ theme }) => ({
    '& .MuiInput-underline:before': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:hover:before': {
      borderBottom: 'none',
    },
  }),
  props => ({
    marginRight: props.marginRight,
    variant: props.variant,
  })
);

const MainButton = styled(Button)(
  ({ theme }) => ({
    // backgroundColor: theme.palette.lightgray.main,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.lightgray.main,
    // color: theme.palette.primary.main,
    fontSize: 16,
    fontFamily: 'ITC Officina Sans Std, sans-serif',
    fontWeight: '600',
    textTransform: 'none',
    borderRadius: '8px',
    border: `2px solid ${theme.palette.primary.main}`,
    padding: '12px 24px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      // backgroundColor: theme.palette.primary.main,
      // color: theme.palette.lightgray.main,
      backgroundColor: theme.palette.lightgray.main,
      color: theme.palette.primary.main,
      boxShadow: '0 4px 12px rgba(0, 75, 141, 0.3)',
      transform: 'translateY(-2px)',
    },
    '&:active': {
      transform: 'translateY(0px)',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    },
  }),
  props => ({
    flex: props.flex,
    fontSize: props.size,
    backgroundColor: props.backgroundColor,
    width: props.width === "fullWidth" ? "100%" : props.width,
    padding: props.padding,
    border: props.border,
    borderRadius: props.borderRadius,
    marginTop: props.marginTop
  })
)

const TatterButton = styled(Button)(
  ({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.lightBackground,
    fontSize: 15,
    fontFamily: 'ITC Officina Sans Std, sans-serif',
    textDecoration: '!important',
    borderRadius: '0px',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: '#7FB3D5',
    },
  }),
  props => ({
    flex: props.flex,
    fontSize: props.fontSize,
    backgroundColor: props.backgroundColor,
    width: props.width,
    height: props.height,
    margin: props.margin,
    borderRadius: props.borderRadius,
    marginTop: props.marginTop,
    padding: props.padding
  })
)

function Description(props) {
  const currentLot = props.currentLot
  const auction = props.auction

  const getRightLotsCount = (lots) => {
    const count = lots.filter(
      (l) =>
        l.lotWithRightId === currentLot.lotWithRightId &&
        l.status === LOT_STATUS.PENDIENTE
    ).length
    return auction.areaId === 1 ? count : count + 1
  }

  const lotWithRightsLength = currentLot.lotWithRightId
    ? getRightLotsCount(auction.lots)
    : null

  if (currentLot) {
    return (
      <Box sx={(theme) => ({
        background: 'linear-gradient(#515A5A  , #707B7C   )',
        padding: 2,
      })}>
        <Box>
          <Title marginTop={10} color={"white"}>Detalles del lote</Title>
          <NormalText>{`Mínimo: ${formatMoney(currentLot.minimum)} ${currentLot.ivaCode}`}</NormalText>
          <NormalText>{`Incremento: ${formatMoney(currentLot.increment)}`}</NormalText>
          <Title marginTop={10} color={"white"}>Descripción:</Title>
          <NormalText>{currentLot.description}</NormalText>
          {lotWithRightsLength ? (
            <Box sx={(theme) => ({ backgroundColor: theme.palette.primary.main, display: "flex", padding: 1, justifyContent: "center", alignItems: "center", marginTop: 1 })}>
              <Title marginTop={10} color={"white"} size={20}>
                {auction.areaId === 1
                  ? `Lote con derecho a tomar ${lotWithRightsLength} lote(s)`
                  : `Lote con derecho: disponibles ${lotWithRightsLength} lote(s)`}
              </Title>
            </Box>
          ) : null}
        </Box>
      </Box>
    )
  } else {
    return (
      <CircularProgress />
    )
  }

}

export { Title, NormalText, NumberText, Field, Description, MainButton, TatterButton }